<section class="nopad">
    <div class="container-fluid register">
        <div class="row">
            <div class="col-md-3 register-left">
                <div class="col-md-12 nopad">
                    <a class="" routerLink='/'><img class="logoImg" src="assets/images/AICTELogo.png" alt="Logo" style="margin-left: 25px;"></a>
                    <a class="" routerLink='/'><img class="logoImg" src="assets/images/SLALogo.png" alt="Logo"></a>
                    <a class="" routerLink='/'><img class="logoImg" src="assets/images/Parakhlogo.png" alt="Logo" style="height: 47px; margin-left: -20px;"></a>
                </div>
                <div class="col-md-12 nopad leftSection">
                    <img class="IconImg" src="https://image.ibb.co/n7oTvU/logo_white.png" alt="" />
                    <h3>Welcome</h3>
                    <p>Enter new password to confirm login!</p>
                    <p>Trying to Login?</p>
                    <a [routerLink]="['/login']" class="mt-3 registerBtn loginBtn">LOGIN</a>
                </div>
            </div>
            <div class="col-md-9 register-right">
                <form [formGroup]="form" (ngSubmit)="onSubmit(form.value)" class="registerFormContainer">
                    <h2 class="registerHeading">Reset Password</h2>
                    <div class="text-center">
                        <mat-form-field [floatLabel]="'never'" class="w-100">
                            <mat-icon matPrefix class="mat-icon-sm mb-2 mr-2 secondary-text-color">mail</mat-icon>
                            <mat-label>Email</mat-label>
                            <input matInput placeholder="Email" formControlName="email" (keypress)="isSpace($event)" autocomplete="new-password" maxlength="60">
                            <mat-error *ngIf="form.controls.email.errors?.required">Email is required</mat-error>
                            <mat-error *ngIf="form.controls.email.hasError('pattern')">Invalid email address
                            </mat-error>
                        </mat-form-field>
                        <mat-form-field [floatLabel]="'never'" class="w-100">
                            <mat-icon matPrefix class="mat-icon-sm mb-2 mr-2 secondary-text-color">lock</mat-icon>
                            <mat-label>Password</mat-label>
                            <input matInput placeholder="Password" formControlName="password" type="password" (keypress)="isSpace($event)" autocomplete="new-password" maxlength="30">
                            <mat-error *ngIf="form.controls.password.errors?.required">Password is required
                            </mat-error>
                            <mat-error *ngIf="form.controls.password.errors?.minlength">The password must be atleast 8 characters long.
                            </mat-error>
                            <mat-error *ngIf="form.controls.password.errors?.pattern">It must contain atleast one lowercase, uppercase, number and special character each.</mat-error>
                            <mat-icon matSuffix matTooltipPosition="right" matTooltip="Password must contain at least a number, lowercase, uppercase and one special character. White Spaces are not allowed.">
                                info</mat-icon>
                        </mat-form-field>
                        <mat-form-field [floatLabel]="'never'" class="w-100">
                            <mat-icon matPrefix class="mat-icon-sm mb-2 mr-2 secondary-text-color">lock</mat-icon>
                            <mat-label>Confirm Password</mat-label>
                            <input matInput placeholder="Confirm Password" formControlName="c_password" type="password" (keypress)="isSpace($event)" autocomplete="new-password" maxlength="30">
                            <mat-error *ngIf="form.controls.c_password.errors?.required">Confirm Password is required
                            </mat-error>

                        </mat-form-field>
                        <button mat-raised-button class="mat-elevation-z6 w-100 mt-3 registerBtn" type="submit">SUBMIT</button>
                    </div>
                </form>
            </div>
        </div>
    </div>
</section>